// Small formatting/id helpers shared across the ICIB admin views —
// ported straight from the sample UI prototype.
export const uid = (prefix) => `${prefix}-${Math.random().toString(36).slice(2, 8)}`;

export const now = () => new Date().toISOString();

// Today as a local YYYY-MM-DD, for a date input's `max` (e.g. no future
// date of birth). Not toISOString(), which is the UTC date and lags NZ.
export const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

export const fmtDate = (s) =>
  s ? new Date(s).toLocaleDateString('en-NZ', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';

export const fmtDT = (s) =>
  s ? new Date(s).toLocaleString('en-NZ', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '—';

export const daysAgo = (s) => Math.floor((Date.now() - new Date(s)) / 86400000);

// Notification "Waiting" column (Overview + Follow-up). A stale_invitation
// is only raised once invited_at is more than STALE_INVITATION_DAYS old
// (ICIB-03a's daily job, §2.12), so its created_at alone understates the
// wait — add the threshold back and show it as a lower bound, since the
// notification payload carries no invited_at. pending_removal_confirmation
// is raised immediately on removal, so created_at is already the real start.
// Keep STALE_INVITATION_DAYS in step with the backend's threshold.
export const STALE_INVITATION_DAYS = 10;
export const fmtWaiting = (n) => (n.type === 'stale_invitation'
  ? `≥ ${daysAgo(n.created_at) + STALE_INVITATION_DAYS} days`
  : `${daysAgo(n.created_at)} days`);

// Bulk-upload result logs: the backend's per-row `results` carry a `row`
// number but no email. `row` is the 1-based position in the rows array
// that was sent, so the panels keep that array (result.sentRows) and look
// the person up by position. Prefers an email the result itself carries.
export const resultRowEmail = (result, r) => r.email || result?.sentRows?.[r.row - 1]?.email || '';

// Phone inputs: keep only digits, spaces and a single leading `+`
// (e.g. "+64 21 555 0110"), so anything else typed or pasted is dropped
// as it's entered. Pair with type="tel" for the phone keypad.
export const phoneChars = (s) => s.replace(/[^\d +]/g, '').replace(/(?!^)\+/g, '');
